<template>
  <section v-if="isGetRequestPending">
    <p-loading />
  </section>
  <section v-else class="documents">
    <header>
      <h1>Documents</h1>
      <section class="action-wrapper">
        <router-link v-if="$hasPermission('templates')" to="/documents/visio/create">+ new</router-link>
      </section>
    </header>
    <p-list
      name="documents"
      :data="collection"
      :total="total"
      :metadata="{
        name: { label: 'Name', width: 'minmax(0, 3fr)' },
        description: { label: 'Description', width: 'minmax(0, 3fr)' },
        tags: { label: 'Tags', width: 'minmax(100px, 2fr)' },
        modifiedAt: { label: 'Last modification', width: '175px' }
      }"
    >
      <template #__actions="{ item }">
        <p-button color="primary" variant="text" title="Download template" @click="download(item.contentUrl)">⤓</p-button>
        <p-button variant="text" title="Edit this form" @click="edit(item.id)"> &#9998;</p-button>
      </template>
    </p-list>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Loading from '@/components/common/Loading';
import Button from '@/components/common/Button';
import List from '@/components/common/List';

export default {
  components: {
    'p-button': Button,
    'p-loading': Loading,
    'p-list': List
  },
  computed: {
    ...mapState({
      collection: s => s.visio.collection,
      total: s => s.visio.total,
      isGetRequestPending: s => s.visio.isGetRequestPending
    }),
    sorted() {
      return this.collection;
    }
  },
  async created() {
    await this.$store.dispatch('visio/getCollection');
  },
  methods: {
    download(url) {
      window.open(`/api/template-storage${url}`, '_blank');
    },
    async edit(id) {
      this.$router.push({ path: `/documents/visio/${id}/edit` });
    }
  }
};
</script>

<style scoped lang="scss">
.documents {
  display: grid;
  padding: 0 0.5rem 0 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: max-content minmax(0, 1fr);
  grid-gap: 0.5rem;
  width: 100%;
  height: 100%;

  > header {
    padding: 0.5rem 0.5rem 0;
    display: flex;
    justify-content: space-between;

    box-sizing: border-box;
    h1 {
      color: var(--theme-on-surface);
      font-size: 1.5rem;
      font-weight: 700;
      margin-right: 0.25rem;
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
